
import React, { useState, useEffect } from "react";
import "@ant-design/compatible/assets/index.css";
import {
    Button,
    Tooltip,
    Row,
    Col,
    Table,
    Spin,
    Select,
    Form,
    Popconfirm,
    Input,
    Tag
} from "antd";
import { convertColumns } from "../../../utils/columnconverter";
import {
    DeleteFilled,
    EditFilled,
    EyeOutlined,
    ClearOutlined,
    SettingOutlined,
    PlusOutlined,
    HistoryOutlined,
    SearchOutlined,
    FileExcelOutlined
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { notify } from "../../../redux/actions";
import { connect } from "react-redux";
import { aictia } from "../../../const/api";
import { useTranslation } from "react-i18next";
import excel from "../../../assets/img/excel.jpeg";
import { useLocation } from "react-router-dom";

const { Option } = Select;
function Portfolio() {
    let mainUrl = "ReyestrOfCompany";
    const location = useLocation();

    const getSavedPage = location.state?.page || 1;

    const [form] = Form.useForm();
    const [individualPostList, setIndividualPostList] = useState([]);
    const [spin, setSpin] = useState(false);
    const [input, setInput] = useState(null);
    const [page, setPage] = useState(getSavedPage);
    const [filter, setFilter] = useState({});
    const [count, setCount] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [category, setCategory] = useState([
        {
            id: 1,
            name: "Layihə"
        },
        {
            id: 2,
            name: "İnnovasiya"
        },
        {
            id: 3,
            name: "Startap"
        },
        {
            id: 4,
            name: "İxtira"
        },
        {
            id: 5,
            name: "Məhsul"
        },
    ]);
    const [typeOfProduct, setTypeOfProduct] = useState([]);
    const [columns, setColumns] = useState([]);
    const [trigger, setTrigger] = useState(0);
    const { t } = useTranslation();
    const role = localStorage.getItem("role");
    const [sortField, setSortField] = useState("");
    const [sortOrder, setSortOrder] = useState(null);
    const cols = [
        { key: "tableIndex", value: "#", con: true },
        {
            key: "company",
            value: t('nameOfEntity'),
            con: true,
        },

        {
            key: "category",
            value: t('category'),
            con: true,
        },
        {
            key: "name",
            value: t('name'),
            con: true,
        },
        {
            key: "typeOfProduct",
            value: t('type'),
            con: true,
        },
    ];
    const individualColumns = [
        {
            title: "#",
            dataIndex: "tableIndex",
            key: "1",
            width: 100,
            className: "tableindex",
        },
        {
            title: t('nameOfEntity'),
            dataIndex: "company",
            key: "2",
            sorter: true,
            sortField: 'CompanyName',
            render: (items) => {
                return items?.name
            },
        },
        // {
        //     title: t('category'),
        //     dataIndex: "category",
        //     key: "2",
        //     render: (items) => {
        //         return items == 1 ? "Layihə" : items == 2 ? "İnnovasiya" : items == 3 ? "Startap" : items == 4 ? "İxtira" : items == 5 ? "Məhsul" : ""
        //     }
        // },
        {
            title: t('category'),
            dataIndex: "category",
            key: "2",
            render: (items) => {
                const categories = {
                    1: { text: "Layihə", color: "gold" },
                    2: { text: "İnnovasiya", color: "green" },
                    3: { text: "Startap", color: "purple" },
                    4: { text: "İxtira", color: "orange" },
                    5: { text: "Məhsul", color: "blue" },
                };

                const category = categories[items];

                return category ? (
                    <Tag color={category.color} style={{ borderRadius: "6px", }}>
                        {category.text}
                    </Tag>
                ) : "";
            }
        },
        {
            title: t('name'),
            dataIndex: "name",
            key: "3",
            sorter: true,
            sortField: 'Name',
        },
        {
            title: t('type'),
            dataIndex: "typeOfProduct",
            key: "4",
            render: (items) => {
                return items?.name
            },
            width: 170

        },
        // {
        //     title: t('url'),
        //     dataIndex: "url",
        //     key: "5",
        //     width: 160,
        //     render: (i) => {
        //         return <p>{i?.replace("https://", "")}</p>;
        //     }
        // },
        {
            title: t('url'),
            dataIndex: "url",
            key: "5",
            width: 160,
            render: (i) => {
                return i ? (
                    <a
                        href={i}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {i.replace("https://", "")}
                    </a>
                ) : "-";
            }
        },
        {
            title: "",
            dataIndex: "id",
            key: "",
            render: (i, index) => {
                return (
                    <div className="flex flex-end">

                        <Tooltip className="ml-5" title={t("edit")} placement="topRight">
                            <Link
                                to={{
                                    pathname: `/portfolio/edit/${i}`,
                                    state: {
                                        page: page, tabKey: index.category.toString(),
                                    },
                                    search: "?tab=" + index.category.toString()
                                }}

                            >
                                <Button className="border-none" type="text" shape="circle">
                                    <EditFilled />
                                </Button>
                            </Link>
                        </Tooltip>
                        <Tooltip
                            className="ml-5"
                            title={t("detailed")}
                            placement="topRight"
                        >
                            <Link
                                to={{
                                    pathname: `/portfolio/view/${i}`,
                                    state: { page: page, tabKey: index.category.toString() },
                                    search: "?tab=" + index.category.toString()
                                }}
                            >
                                <Button className="border-none" type="text" shape="circle">
                                    <EyeOutlined />
                                </Button>
                            </Link>
                        </Tooltip>
                        {
                            role === "Admin" && (

                                <Popconfirm
                                    placement="topRight"
                                    title={t("areYouSure")}
                                    onConfirm={() => deletePost(index)}
                                    okText={t("yes")}
                                    cancelText={t("no")}
                                >
                                    <Tooltip className="ml-5" title={t("delete")}>
                                        <Button className="border-none" type="text" shape="circle">
                                            <DeleteFilled />
                                        </Button>
                                    </Tooltip>
                                </Popconfirm>)
                        }


                    </div>
                );
            },
        },
    ];
    const deletePost = async (i) => {
        if (i.category === 1) {
            await aictia
                .delete(`Project/${i.id}`)
                .then((res) => {
                    getPortfel();
                    notify("silindi", true);
                })
                .catch((res) => {
                    notify(res.err, false);
                });
        }
        if (i.category === 2) {
            await aictia
                .delete(`Innovation/${i.id}`)
                .then((res) => {
                    getPortfel();
                    notify("silindi", true);
                })
                .catch((res) => {
                    notify(res.err, false);
                });
        }
        if (i.category === 3) {
            await aictia
                .delete(`Startup/${i.id}`)
                .then((res) => {
                    getPortfel();
                    notify("silindi", true);
                })
                .catch((res) => {
                    notify(res.err, false);
                });
        }
        if (i.category === 4) {
            await aictia
                .delete(`Invention/${i.id}`)
                .then((res) => {
                    getPortfel();
                    notify("silindi", true);
                })
                .catch((res) => {
                    notify(res.err, false);
                });
        }
        if (i.category === 5) {
            await aictia
                .delete(`Product/${i.id}`)
                .then((res) => {
                    getPortfel();
                    notify("silindi", true);
                })
                .catch((res) => {
                    notify(res.err, false);
                });
        }
    };


    const getPortfel = async (paramss) => {
        setSpin(true);
        // API sorğusu üçün parametrlər
        const params = {
            PerDataCount: (page - 1) * pageSize,
            GetDataCount: pageSize,
            ...(sortField && sortOrder &&
            {
                OrderName: sortField,
                IsDescending: sortOrder === 'descend' // true / false / null
            }
            )
        };
        // Əlavə query parametrlərini hazırlayırıq
        const queryParts = [];


        if (paramss?.category) {
            paramss.category.forEach(element => {

                queryParts.push(`Category=${element}`);
            });
        }
        if (paramss?.QueryParam) {
            queryParts.push(`QueryParam=${paramss.QueryParam}`);
        }

        if (paramss?.typeOfProduct) {
            paramss.typeOfProduct.forEach((element, index) => {
                queryParts.push(`Type[${index}].TypeId=${typeOfProduct[element].id}&Type[${index}].Category=${typeOfProduct[element].category}`);
            });
        }

        // Query stringi formalaşdırırıq
        const queryString = queryParts.length ? `?${queryParts.join("&")}` : "";

        // API çağırışı
        await aictia.get(`Portfolio${queryString}`, { params })
            .then((res) => {
                if (res.data) {
                    setSpin(false);
                    setIndividualPostList(
                        res.data.data.map((d, index) => ({
                            ...d,
                            key: index + 1,
                            index,
                            tableIndex: res.data.count - index - (page - 1) * pageSize,
                        }))
                    );
                    setCount(res.data.count);
                }
            })
            .catch(() => setSpin(false)); // Əgər səhv olarsa, spin-i söndür
    };


    const onSearch = (values) => {
        setPage(1)

        const params = {
            ...values,
            QueryParam: values?.QueryParam,
            currentPage: 1
        }

        setFilter(params);
        getPortfel(params)
    };
    const clearFilter = () => {
        form.resetFields();
        setPage(1);
        setInput(null);
        setFilter({});
        getPortfel();
    };
    const getTypeOfProduct = () => {
        aictia.get("Portfolio/PortfolioTypes").then((res) => {
            setTypeOfProduct(res.data);
        });
    };
    const columnsData = (e) => {
        setColumns(
            individualColumns.filter((p, index) => {
                if (e.includes(p.dataIndex)) {
                    return p;
                }
                if (e.length === 0) {
                    return individualColumns;
                }
                if (p.dataIndex === "tableIndex") {
                    return p;
                }
                if (p.dataIndex === "id") {
                    return p;
                }
            })
        );
        setTrigger(trigger + 1);
    };

    useEffect(() => {
        getTypeOfProduct();
    }, [t]);

    useEffect(() => {
        getPortfel(filter);
    }, [page, pageSize, sortField, sortOrder, t]);
    const sortedColumns = individualColumns.map((col) => {
        if (col.sortField === sortField) {
            return {
                ...col,
                sortOrder: sortOrder, // 'ascend' | 'descend' | null
            };
        }
        return {
            ...col,
            sortOrder: null, // digər sütunlarda heç nə olmasın
        };
    });

    const handleSort = (pagination, filters, sorter) => {
        const column = sorter.column?.sortField;

        if (sorter.order === 'ascend') {
            setSortField(column || "");
            setSortOrder('ascend'); // göndəriləcək IsDescending: false
        } else if (sorter.order === 'descend') {
            setSortField(column || "");
            setSortOrder('descend'); // göndəriləcək IsDescending: true
        } else {
            setSortField("");
            setSortOrder(null); // sıralama yoxdur
        }
    };
    return (
        <div>
            <Row gutter={[10, 10]}>
                <Col xs={24}>
                    <div className="border flex-between page-heading p-1 flex mt-0 bg-white" style={{ borderRadius: "20px" }}>
                        <div className="page-name">
                            <Form onFinish={onSearch} form={form}>
                                <div className="commontask bg-white ">
                                    <Row className={"mt-5"} gutter={[8, 8]}>
                                        <Col xs={24} sm={12} md={5} lg={6} xl={5} style={{ marginLeft: "10px" }}>
                                            <Form.Item
                                                name={"QueryParam"}
                                            // rules={[noWhitespace(t("inputError"))]}
                                            >

                                                <Input placeholder={t("search")} prefix={<SearchOutlined style={{ color: "#bfbfbf", margin: "0 8px 0 0" }} />} size={"small"} style={{ borderRadius: "12px" }} />
                                            </Form.Item>
                                        </Col>
                                        <Col md={5} sm={12} xs={24} lg={6} xl={5}>
                                            <Form.Item
                                                name={"category"}
                                            // rules={[noWhitespace(t("inputError"))]}
                                            >
                                                <Select placeholder={t('category')} maxTagCount={1} mode="multiple" className="custom-select" maxTagPlaceholder={(omittedValues) => (
                                                    <span>+{omittedValues.length}</span>
                                                )}>
                                                    {category.map((p, index) => {
                                                        return (
                                                            <Option key={index} value={p.id}>
                                                                {p.name}
                                                            </Option>
                                                        );
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={5} sm={12} xs={24} lg={6} xl={5}>
                                            <Form.Item
                                                name={"typeOfProduct"}
                                            // rules={[noWhitespace(t("inputError"))]}
                                            >
                                                <Select placeholder={t('type')} maxTagCount={1} mode="multiple" className="custom-select" maxTagPlaceholder={(omittedValues) => (
                                                    <span>+{omittedValues.length}</span>
                                                )}>
                                                    {typeOfProduct.map((p, index) => {
                                                        return (
                                                            <Option key={index} value={p.index}>
                                                                {p.typeName}
                                                            </Option>
                                                        );
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        {/* <Col md={5} sm={12} xs={24} lg={6} xl={5}>
                      <Form.Item
                        name={"ActivitiyIds"}
                      // rules={[noWhitespace(t("inputError"))]}
                      >
                        <Select placeholder={t('fieldOfActivity')} maxTagCount={1} mode="multiple"
                          maxTagPlaceholder={(omittedValues) => (
                            <span>+{omittedValues.length}</span>
                          )}>
                          {activity.map((p, index) => {
                            return (
                              <Option key={index} value={p.id}>
                                {p.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col md={5} sm={12} xs={24} lg={6} xl={5}>
                      <Form.Item
                        name={"ActivityStatus"}
                      // rules={[noWhitespace(t("inputError"))]}
                      >
                        <Select placeholder={t('Status')} size="medium">
                          <Option value={false}>{t('Bağlanmış şirkətlər')}</Option>
                          <Option value={true}>{t('Fəaliyyət göstərən şirkətlər')}</Option>
                        </Select>
                      </Form.Item>
                    </Col> */}

                                        <Col md={3} sm={12} xs={24} lg={3} xl={2} style={{ maxWidth: "70px", marginTop: "4px" }}>
                                            <Form.Item name={" "}>
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    className="w-100"
                                                    style={{
                                                        padding: "6px 10px",
                                                        height: "36px",
                                                        fontSize: "12px",
                                                        fontWeight: 700,
                                                        borderRadius: "8px",
                                                    }}
                                                >
                                                    {t("search")}
                                                </Button>
                                            </Form.Item>
                                        </Col>

                                        <Col md={3} sm={12} xs={24} lg={3} xl={2} style={{ maxWidth: "60px", marginTop: "4px" }}>
                                            <Form.Item name={" "}>
                                                <Button
                                                    type="primary"
                                                    size={"large"}
                                                    onClick={() => {
                                                        clearFilter();
                                                    }}
                                                    style={{
                                                        padding: "6px 10px",
                                                        height: "36px",
                                                        fontSize: "12px",
                                                        fontWeight: 700,
                                                        borderRadius: "8px",
                                                    }}
                                                    className="w-100"
                                                    htmlType="submit"
                                                >
                                                    <ClearOutlined style={{ fontSize: "18px" }} />
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            </Form>
                        </div>
                        <Form className="register-head head-icons" >

                            <div className="register" >
                                <label className="labelPlace">
                                    {" "}
                                    <SettingOutlined  />
                                </label>

                                <Select
                                    dropdownMatchSelectWidth={false}
                                    showSearch={false}
                                    mode="multiple"
                                    onChange={(e) => columnsData(e)}
                                >
                                    {individualColumns.map((p, index) => {
                                        return (
                                            p.dataIndex !== "tableIndex" &&
                                            p.dataIndex !== "id" && p.dataIndex !== "packetOfAictia" && (
                                                <Option key={index} value={p.dataIndex}>
                                                    {p.title}
                                                </Option>
                                            )
                                        );
                                    })}
                                </Select>
                            </div>

                            <div>
                                {/* <Button className="file-icon">
                                    <img src={excel} />
                                </Button> */}
                                <Button
                                    type="primary"
                                    title="Excel-ə ixrac et"
                                    icon={<FileExcelOutlined />}
                                    style={{
                                        backgroundColor: "#059669",
                                        borderColor: "#059669",
                                        color: "#fff",
                                        width: "36px",
                                        height: "36px",
                                        borderRadius: "8px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "1px 0px 0px",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                    }}
                                />
                            </div>

                            <div style={{ marginRight: "10px" }}>
                                <Link
                                    to={{
                                        pathname: `portfolio/create`,
                                        state: { locales: null },
                                    }}
                                >
                                    <Button type="primary" style={{
                                        width: "36px",
                                        height: "36px",
                                        padding: 0,
                                        backgroundColor: "#0c82f4",
                                        borderColor: "#0c82f4",
                                        borderRadius: "8px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#fff",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                        cursor: "pointer",
                                    }}><PlusOutlined /></Button>
                                </Link>
                            </div>

                        </Form>

                    </div>
                </Col>
                <>
                    {spin ? (
                        <Col xs={24}>
                            <div className="flex animated fadeInUp bg-white all-center p-2" style={{ borderRadius: "20px" }}>
                                <Spin size={"large"} />
                            </div>
                        </Col>
                    ) : (
                        <Col xs={24}>
                            <div
                                style={{
                                    borderRadius: "20px",
                                    overflow: "hidden",
                                    background: "#fff",
                                }}
                            >
                                <Table
                                    size="small"
                                    className="bg-white animated fadeIn"
                                    columns={trigger === 0 ? sortedColumns : columns}
                                    dataSource={convertColumns(individualPostList, cols)}
                                    pagination={{
                                        pageSize: pageSize,
                                        current: page,
                                        total: count,
                                        locale: { items_per_page: "/ səhifələnmə" },
                                        onChange: (page, pageSize) => {
                                            setPage(page);
                                            setPageSize(pageSize);
                                        },
                                    }}
                                    onChange={handleSort}

                                />
                            </div>
                        </Col>
                    )}
                </>
            </Row>
        </div>
    );
}

export default connect(null, { notify })(Portfolio);






